import { render, staticRenderFns } from "./busInformation.vue?vue&type=template&id=faa52b56&scoped=true&"
import script from "./busInformation.vue?vue&type=script&lang=js&"
export * from "./busInformation.vue?vue&type=script&lang=js&"
import style0 from "./busInformation.vue?vue&type=style&index=0&id=faa52b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa52b56",
  null
  
)

export default component.exports